export enum Routes {
  BaseName = "/",
  HomePage = "/challenges",
  ExplorePage = "/explore",
  // CreatePage = "/create",
  ThemesPage = "/themes",
}
